export const asteroidContractAddress = "0x6e4c6D9B0930073e958ABd2ABa516b885260b8Ff";